var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpperInformationHeaderMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.8125C5.58274 2.8125 2.8125 5.58274 2.8125 9C2.8125 12.4173 5.58274 15.1875 9 15.1875C12.4173 15.1875 15.1875 12.4173 15.1875 9C15.1875 5.58274 12.4173 2.8125 9 2.8125ZM1.6875 9C1.6875 4.96142 4.96142 1.6875 9 1.6875C13.0386 1.6875 16.3125 4.96142 16.3125 9C16.3125 13.0386 13.0386 16.3125 9 16.3125C4.96142 16.3125 1.6875 13.0386 1.6875 9Z",
    fill: "#424549"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.73815 6.09245C7.94597 5.86154 8.30164 5.84282 8.53255 6.05064L11.345 8.58189C11.4636 8.68857 11.5313 8.84054 11.5313 9C11.5313 9.15946 11.4636 9.31143 11.345 9.4181L8.53255 11.9493C8.30164 12.1572 7.94597 12.1385 7.73815 11.9075C7.53033 11.6766 7.54905 11.321 7.77996 11.1131L10.1279 9L7.77996 6.88685C7.54905 6.67903 7.53033 6.32337 7.73815 6.09245Z",
    fill: "#424549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperInformationHeaderMore);
export default __webpack_public_path__ + "static/media/upper-information-header-more.44a5f8f7ed3b066eb822347c6521f41f.svg";
export { ForwardRef as ReactComponent };